import NoticeForm from "./NoticeForm";
import { useForm } from "react-hook-form";
import Card from "../Reusable/Card";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { createNoticeValidationForm } from "../../utils/validationSchemas";

const EditNotice = (props: any) => {
  const { handleEdit, isPatchLoading, NoticeData } = props;
  const {
    handleSubmit,
    register,
    setValue,
    setError,
    control,
    watch,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(createNoticeValidationForm),
    defaultValues: async () => {
      return {
        title: NoticeData?.title,
        content: NoticeData?.content,
        theme: NoticeData?.theme,
        start_date: NoticeData?.start_date,
        expiry_date: NoticeData?.expiry_date,
        type: {
          id: NoticeData?.type,
          name: NoticeData?.type,
        },
      };
    },
  });

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isPatchLoading}
      >
        <NoticeForm
          register={register}
          setValue={setValue}
          getValues={getValues}
          setError={setError}
          errors={errors}
          watch={watch}
          control={control}
          clearErrors={clearErrors}
          NoticeData={NoticeData}
        />
      </FormLayout>
    </>
  );
};

export default EditNotice;
